import * as React from 'react';
import { ArticleHeading1, InlineText1 } from '@cian/ui-kit/typography';
import * as style from './Price.css';

export interface IPriceProps {
  pricePerMeter: string;
  pricePerObject: string;
}

export function Price({ pricePerMeter, pricePerObject }: IPriceProps) {
  return (
    <div className={style['price']}>
      <div className={style['heading']}>
        <ArticleHeading1 color={'text-inverted-default'} fontWeight={'bold'}>
          {pricePerObject}
        </ArticleHeading1>
      </div>
      <InlineText1 color={'text-inverted-default'}>{pricePerMeter}</InlineText1>
    </div>
  );
}
